import * as React from "react";

const NotFound = () => {
    return (
        <div className="container py-3">
            <div className="alert alert-warning">
                This registration link is not valid!
            </div>
        </div>
    );
};

export default NotFound;
